import React from 'react';

import DataGridColumn from 'models/utils/common/data-grid/data-grid-column-model';
import MultilineEllipsis from 'components/common/multi-line-ellipsis-text-component';

export const getMonitoringColumns = () => {
  let monitoringColumns = [
    new DataGridColumn({
      key: 'clientName',
      header: 'admin.module.monitoring.client.name-heading',
      width: '25%',
      formatter: (rowData, { rowKey }) => {
        const colId = `admin-module-client-name-col-${rowKey}`;
        return (
          <MultilineEllipsis
            toolTipID={colId}
            text={rowData.clientName}
            isNotInternationalized
          />
        );
      },
    }),
    new DataGridColumn({
      key: 'activeStatements',
      header: 'admin.module.monitoring.active.statements-heading',
      width: '20%',
      formatter: (rowData, { rowKey }) => {
        const colId = `admin-module-active-statements-col-${rowKey}`;
        return (
          <MultilineEllipsis
            toolTipID={colId}
            text={rowData.activeStatements}
            isNotInternationalized
          />
        );
      },
    }),
    new DataGridColumn({
      key: 'wrappedStatements',
      header: 'admin.module.monitoring.wrapped.statements-heading',
      width: '15%',
      formatter: (rowData, { rowKey }) => {
        const colId = `admin-module-wrapped-statements-col-${rowKey}`;
        return (
          <MultilineEllipsis
            toolTipID={colId}
            text={rowData.wrappedupStatements}
            isNotInternationalized
          />
        );
      },
    }),
    new DataGridColumn({
      key: 'deletedStatements',
      header: 'admin.module.monitoring.deleted.statements-heading',
      width: '15%',
      formatter: (rowData, { rowKey }) => {
        const colId = `admin-module-deleted-statements-col-${rowKey}`;
        return (
          <MultilineEllipsis
            toolTipID={colId}
            text={rowData.deletedStatements}
            isNotInternationalized
          />
        );
      },
    }),
    new DataGridColumn({
      key: 'country',
      header: 'admin.module.monitoring.country-heading',
      width: '15%',
      formatter: (rowData, { rowKey }) => {
        const colId = `admin-module-country-col-${rowKey}`;
        return (
          <MultilineEllipsis
            toolTipID={colId}
            text={rowData.containerCode}
            isNotInternationalized
          />
        );
      },
    }),
  ];
  return monitoringColumns;
};
